import { render, staticRenderFns } from "./TakeoutInformation.vue?vue&type=template&id=47ade8dd"
import script from "./TakeoutInformation.vue?vue&type=script&lang=ts"
export * from "./TakeoutInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports